<template>
  <div :style="{width: '100%', background: '#F3F3F3'}">
    <div class="top-fill">
    </div>
    <div class="title">
      <img src="../assets/mq_blue_logo.png" class="logo"/>
      <div class="vip-center" @click="loginOut">
        <div class="vip-word">
          退出登录
        </div>
      </div>
    </div>
    <div class="for-content">
      <div class="table">
        <div class="table-title">
          <div class="table-title-1 table-title-s">
            #
          </div>
          <div class="table-title-2 table-title-s">
            监测用户
          </div>
          <div class="table-title-3 table-title-s">
            设备信息
          </div>
          <div class="table-title-4 table-title-s">
            监测信息
          </div>
          <div class="table-title-5 table-title-s">
            最新血糖
          </div>
          <div class="table-title-6 table-title-s">
            操作
          </div>
        </div>
        <div v-for="(item,index) in userInfos">
          <div class="table-content-line" :style="{background: lineBg(index)}">
            <div class="table-content-box-1">
              {{index+1}}
            </div>
            <div class="table-content-box-2">
              <div style="line-height: 20px;">手机号：{{item.monitorPhone}}</div>
              <div style="line-height: 20px;">姓名：{{item.name}}</div>
              <div style="line-height: 20px;">年龄：{{item.age}}</div>
              <div style="line-height: 20px;">性别：{{getSex(item.sex)}}</div>
              <div style="line-height: 20px;">患病类型：{{item.diabetesKind}}</div>
            </div>
            <div class="table-content-box-3">
              <div style="line-height: 20px;">设备参数：{{item.qrCode}} ({{item.deviceDay}})天 {{item.bleId}}</div>
              <div style="line-height: 20px;">平台信息：{{item.phoneAgent.slice(0,14)}}</div>
              <div style="line-height: 20px;">App版本：{{item.phoneAgent.slice(15)}}</div>
              <div style="line-height: 20px;">代理商：</div>
              <div style="line-height: 20px;">周期编号：{{item.snapshotId}}</div>
            </div>
            <div class="table-content-box-4">
              <div style="line-height: 20px;display: flex">
                监测时长：
                <div style="color: #009CEE">
                  {{getMonitorTime(item)}}
                </div>
              </div>
              <div style="line-height: 20px;">开始时间：{{item.startDate}}</div>
              <div style="line-height: 20px;display: flex">
                监测状态：
                <div class="monitor-status" :style="{background:monitorBg(item.monitor)}">
                  {{getMonitor(item.monitor)}}
                </div>
              </div>
            </div>
            <div class="table-content-box-5">
              <div style="line-height: 20px;">最新上传时间：{{item.lastDataBagTime}}</div>
              <div style="line-height: 20px;">最新包号：{{item.lastDataBag}}</div>
              <div style="line-height: 20px;">最新血糖：{{item.lastMachineBloodSugar}}</div>
              <div style="line-height: 20px;">设备电流：{{item.lastOriginI}}</div>
            </div>
            <div class="table-content-box-6" @click="showDetail(item)">
              查看详情
            </div>
          </div>
        </div>
      </div>
    </div>
    <Report ref="report" @getDayPhoto="getUrl"></Report>
    <div v-for='(item,index) in items' class='okhttp'>
      <PrintDataPreView2 v-bind:itemData ='item' @showPhoto='setUrl' v-bind:basic='basicInfo'></PrintDataPreView2>
    </div>
  </div>
</template>

<script>
import {postAction} from '../network/GetAndPost'
import Report from './Report'
import Vue from 'vue'
import PrintDataPreView2 from './PrintDataPreView2'

export default {
  name: 'PersonalMain',
  components: {Report, PrintDataPreView2},
  computed:{
    fullHeight () {
      return window.innerHeight + 'px'
    },
    lineBg () {
      return function (lineNo){
        if(lineNo % 2 === 0){
          return '#ECF9FF'
        }else
          return '#FFFFFF'
      }
    }
  },
  created () {
    document.body.style.overflow = 'scroll'
  },
  data () {
    return {
      userInfos: [],
      snapshotListUrl: '/index/snapshot/index',
      basicInfo:{},
      items:[]
    }
  },
  methods:{
    setUrl:function(url){
      this.$refs.report.setUrl(url);
    },
    getUrl:function(params,basicInfo,index){
      // this.$refs.printPreView.getImgUrl(params,basicInfo,index);
      this.basicInfo = basicInfo
      this.items.push(params)
    },
    loginOut(){
      this.$router.go(-1)
    },
    showDetail(record){
      record.id = record.snapshotId
      this.$refs.report.view(record);
    },
    getSex(a){
      if(a === 1){
        return "男"
      }else if(a === 2){
        return "女"
      }else if(a === 3){
        return "未知"
      }
    },
    monitorBg(a){
      if(a === 0){
        return "#D5D5D5"
      }else if(a === 1){
        return "#20DBA5"
      }else if(a === 2){
        return "#009CEE"
      }else if(a === 3){
        return "#FF5E5E"
      }
    },
    getMonitor(a){
      //是否在监测状态（0：结束，1：监测中 ，2、极化中；3、参比未输入；）
      if(a === 0){
        //this.monitorBg = "#D5D5D5"
        return "已结束"
      }else if(a === 1){
        //this.monitorBg = "#20DBA5"
        return "监测中"
      }else if(a === 2){
        //this.monitorBg = "#009CEE"
        return "极化中"
      }else if(a === 3){
        //this.monitorBg = "#FF5E5E"
        return "参比未输入"
      }
    },
    getMonitorTime(item){
      let time
      if(item.endDate === ""){
        time = this.moment().format('x') - this.moment(item.startDate).format('x')
      }else {
        time = this.moment(item.endDate).format('x') - this.moment(item.startDate).format('x')
      }
      let dd = Math.floor(time/86400000)
      let hh = Math.floor((time-dd*86400000)/3600000)
      let mm = Math.floor((time-dd*86400000-hh*3600000)/60000)
      return dd+"天"+hh+"小时"+mm+"分钟"
    }
  },
  mounted () {
    // let params = new FormData();
    // params.append('page_size','100')
    postAction(this.snapshotListUrl,{"page_index": 1, "page_size": 100}).then((res)=>{
      console.log(res)
      this.userInfos = res.result.data
    })
  }
}
</script>

<style>

.monitor-status{
  width: fit-content;
  height: fit-content;
  border-radius: 10px;
  padding: 2px 7px 2px 7px;
  font-size: 10px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 14px;
}

.table-content-line{
  height: 146px;
  display: flex;
  width: 1660px;
  font-size: 12px;
  font-weight: 400;
}
.for-content{
  margin-top: 58px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.table-title-s{
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 20px;
}
.table-title-1{
  width: 188px;
}
.table-content-box-1{
  width: 188px;
  height: 146px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table-title-2{
  width: 283px;
  justify-content: start;
}
.table-content-box-2{
  width: 283px;
  height: 146px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
}

.table-title-3{
  width: 434px;
  justify-content: start;
}
.table-content-box-3{
  width: 434px;
  height: 146px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
}
.table-title-4{
  width: 312px;
  justify-content: start;
}
.table-content-box-4{
  width: 312px;
  height: 146px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
}
.table-title-5{
  width: 354px;
  justify-content: start;
}
.table-content-box-5{
  width: 354px;
  height: 146px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
}
.table-title-6{
  width: 150px;
}
.table-content-box-6{
  width: 150px;
  height: 146px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #009CEE ;
  cursor: pointer;
}

.table-title{
  width: 1660px;
  height: 48px;
  background: #009CEE;
  display: flex;
}
.top-fill{
  height: 40px;
}
.vip-center {
  padding: 7px 14px;
  width: fit-content;
  height: fit-content;
  background: #212121;
  border-radius: 19px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 195px;
}

.vip-word {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}

.title {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
}

.logo {
  margin-left: 130px;
  width: 231px;
  height: 36px;
}


</style>



// WEBPACK FOOTER //
// src/components/PersonalMain.vue